/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import PlanJouney from "./PlanJouney";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getMapData, getStationNameForCode } from "../../../shared/utils/mapUtils";
import { centerMap, highlightPath } from "../../../shared/utils/mapAnimations";
import { drawMap, formatData } from "../../../shared/utils/mapInit";
import { lines } from "../../../shared/data/lines";
import { coords } from "../../../shared/data/coords";
import Popup from "./Popup";
import { AddZoom, CloseBtn, Locality, Minus, St } from "../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import moment from "moment";
import SecondaryBtn from "../../common/form/SecondaryBtn";

const Map = () => {
  const { t } = useTranslation('common');
  const [journeyPlan, setJourneyPlan] = useState<any>({
    from: '',
    fromName: '',
    to: '',
    toName: '',
    date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
    advanced: 'least-distance',
    fromType: "",
    toType: "",
    journey: "one_way"
  })
  const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
  const [routeData, setRouteData] = useState<any>(null)
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [plottedMap, setPlottedMap] = useState<any>()
  const [lastClickedStation, setLastClickedStation] = useState<string>('')
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(!!routeData ? false : true);
  const [isNoRouteFound, setNoRouteFound] = useState<boolean>(false);
  const [bookErr, setBookErr] = useState<string>("");
  let [fromStPh, setFromStPh] = useState<any>(t("passenger.home.banner.trip_planner.form.from_placeholder"));
  let [fromStSearch, setFromStSearch] = useState<any>('');
  let [toStSearch, setToStSearch] = useState<any>('');
  let [toStPh, setToStPh] = useState<any>(t("passenger.home.banner.trip_planner.form.to_placeholder"));
  const [fromErr, setFromErr] = useState<boolean>(false)
  const [toErr, setToErr] = useState<boolean>(false)
  let [fromSt, setFromSt] = useState<any>(
    !!journeyPlan?.fromName ?
      (journeyPlan?.fromType === "station" ? {
        label: journeyPlan?.fromName,
        code: journeyPlan?.from,
        value: journeyPlan?.from,
        option: <div className="flex items-center gap-[8px]">
          <St />
          <p className="text-sm font-bold text-[#5A5A5A]">{journeyPlan?.fromName}</p>
        </div>,
        type: journeyPlan?.fromType
      } :
        {
          label: journeyPlan?.fromName,
          code: journeyPlan?.fromName,
          value: journeyPlan?.fromName,
          option: <div className="flex items-center">
            <div className="pr-[8px]">
              <Locality />
            </div>
            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{journeyPlan?.fromName}</p>
          </div>,
          type: journeyPlan?.fromType
        }
      )
      :
      null
  )
  let [toSt, setToSt] = useState<any>(
    !!journeyPlan?.toName ?
      (journeyPlan?.toType === "station" ? {
        label: journeyPlan?.toName,
        code: journeyPlan?.to,
        value: journeyPlan?.to,
        option: <div className="flex items-center gap-[8px]">
          <St />
          <p className="text-sm font-bold text-[#5A5A5A]">{journeyPlan?.toName}</p>
        </div>,
        type: journeyPlan?.toType
      } :
        {
          label: journeyPlan?.toName,
          code: journeyPlan?.toName,
          value: journeyPlan?.toName,
          option: <div className="flex items-center">
            <div className="pr-[8px]">
              <Locality />
            </div>
            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{journeyPlan?.toName}</p>
          </div>,
          type: journeyPlan?.toType
        }
      )
      :
      null)
  const [submit, setSubmit] = useState<boolean>(false)
  const [saveRoute, setSaveRoute] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [fromData, setFromData] = useState<any[]>([])
  const [toData, setToData] = useState<any[]>([])
  const [type, setType] = useState<number>(1);
  const [saved, setSaved] = useState<boolean>(false)
  const [tripLoading, setTripLoading] = useState<boolean>(isLogin ? true : false)
  const [downtime, setDownTime] = useState<any>(null)
  const [journeyData, setJourneyData] = useState<any>(null)
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const handleButtonClick = (station: any) => {
    Array.prototype.forEach.call(
      document.querySelectorAll(`.${station}Flags div`),
      (item) => {
        item.style.visibility = 'hidden'
      }
    )
    if (station === 'to') {
      let obj: any = {
        ...journeyPlan, to: lastClickedStation,
        toName: getStationNameForCode(lastClickedStation, lang),
        toType: 'station',
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm')
      }

      setJourneyPlan(obj)

      if (!!obj?.from && !!obj?.to) {
        if (params?.lang) {
          navigate(`/${params?.lang}/map?from=${obj?.from}&fromName=${obj?.fromName}&to=${obj?.to}&toName=${obj?.toName}&fromType=${obj?.fromType}&toType=${obj?.toType}&date=${obj?.date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        } else {
          navigate(`/map?from=${obj?.from}&fromName=${obj?.fromName}&to=${obj?.to}&toName=${obj?.toName}&fromType=${obj?.fromType}&toType=${obj?.toType}&date=${obj?.date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        }
      }
    } else {
      let obj: any = {
        ...journeyPlan, from: lastClickedStation,
        fromName: getStationNameForCode(lastClickedStation, lang),
        fromType: 'station',
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm')
      }
      setJourneyPlan(obj)

      if (!!obj?.from && !!obj?.to) {
        if (params?.lang) {
          navigate(`/${params?.lang}/map?from=${obj?.from}&fromName=${obj?.fromName}&to=${obj?.to}&toName=${obj?.toName}&fromType=${obj?.fromType}&toType=${obj?.toType}&date=${obj?.date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        } else {
          navigate(`/map?from=${obj?.from}&fromName=${obj?.fromName}&to=${obj?.to}&toName=${obj?.toName}&fromType=${obj?.fromType}&toType=${obj?.toType}&date=${obj?.date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        }
      }
    }
    setIsPopupOpen(false);
    (document.getElementById(
      lastClickedStation + station + 'Flag'
    ) as any).style.visibility = 'visible'
  }

  const showPopup = (name: any, currentZoom: any) => {
    setLastClickedStation(name)
    centerMap(name, currentZoom)
    setIsPopupOpen(true)
  }

  useEffect(() => {
    !!lang && setPlottedMap(drawMap(formatData(lang, lines["mmrcl"], coords["mmrcl"], {}), showPopup))
  }, [lang])

  const zoomIn = () => {
    if (plottedMap) {
      plottedMap.zoomIn()
    }
  }

  const zoomOut = () => {
    if (plottedMap) {
      plottedMap.zoomOut()
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!!params.get('from') && !!params.get('fromName') && !!params.get('to') && !!params.get('toName') && !!params.get('fromType') && !!params.get('toType') && !!params?.get('date') && !!params?.get('journey')) {
      let obj: any = {
        from: params.get('from'),
        fromName: params.get('fromName'),
        to: params.get('to'),
        toName: params.get('toName'),
        // date: params.get('date'),
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
        advanced: 'least-distance',
        fromType: params.get('fromType'),
        toType: params.get('toType'),
        journey: params.get('journey')
      };
      setJourneyPlan(obj)
      !!lang && getRoute(obj, lang)
      setType(params?.get('journey') === "one_way" ? 1 : 2)

      setFromSt(
        !!obj?.fromName ?
          (obj?.fromType === "station" ? {
            label: obj?.fromName,
            code: obj?.from,
            value: obj?.from,
            option: <div className="flex items-center gap-[8px]">
              <St />
              <p className="text-sm font-bold text-[#5A5A5A]">{obj?.fromName}</p>
            </div>,
            type: obj?.fromType
          } :
            {
              label: obj?.fromName,
              code: obj?.fromName,
              value: obj?.fromName,
              option: <div className="flex items-center">
                <div className="pr-[8px]">
                  <Locality />
                </div>
                <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{obj?.fromName}</p>
              </div>,
              type: obj?.fromType
            }
          )
          :
          null)
      setToSt(!!obj?.toName ?
        (obj?.toType === "station" ? {
          label: obj?.toName,
          code: obj?.to,
          value: obj?.to,
          option: <div className="flex items-center gap-[8px]">
            <St />
            <p className="text-sm font-bold text-[#5A5A5A]">{obj?.toName}</p>
          </div>,
          type: obj?.toType
        } :
          {
            label: obj?.toName,
            code: obj?.toName,
            value: obj?.toName,
            option: <div className="flex items-center">
              <div className="pr-[8px]">
                <Locality />
              </div>
              <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{obj?.toName}</p>
            </div>,
            type: obj?.toType
          }
        )
        :
        null)
      setFromStSearch(obj?.fromName || '')
      setToStSearch(obj?.toName || '')
    }

    if (!!params.get('to') && !!params.get('toName') && !!params.get('toType') && !!params?.get('date') && !!!params.get('from') && !!!params.get('fromName') && !!!params.get('fromType')) {
      setJourneyPlan({
        ...journeyPlan,
        to: params.get('to'),
        toName: params.get('toName'),
        toType: params.get('toType'),
        // date: params.get('date')
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm')
      })

      setToSt(!!params.get('toName') ?
        (params.get('toType') ? {
          label: params.get('toName'),
          code: params.get('to'),
          value: params.get('to'),
          option: <div className="flex items-center gap-[8px]">
            <St />
            <p className="text-sm font-bold text-[#5A5A5A]">{params.get('toName')}</p>
          </div>,
          type: params.get('toType')
        } :
          {
            label: params.get('toName'),
            code: params.get('toName'),
            value: params.get('toName'),
            option: <div className="flex items-center">
              <div className="pr-[8px]">
                <Locality />
              </div>
              <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{params.get('toName')}</p>
            </div>,
            type: params.get('toType')
          }
        )
        :
        null)
      setToStSearch(params.get('toName') || '')
    }
  }, [location, lang, params])

  const getRoute = async (obj: any, language: any) => {
    setLoading(true)
    setSubmit(true)
    const data = await getMapData(obj, language)
    setJourneyData(data)

    if (data?.route && data?.route?.length) {
      if (data?.localities?.length > 0 && (data?.localities[0]?.source_stn_localities?.length > 0 || data?.localities[0]?.destination_stn_localities?.length > 0)) {
        let locality: any = {};
        if (data?.localities[0]?.source_stn_localities?.length > 0 && !data?.localities[0]?.destination_stn_localities) {
          locality.from = {
            fromSt: {
              name: data?.localities[0]?.source_stn_localities[0]?.name,
              code: "fromlt",
              name_hi: data?.localities[0]?.source_stn_localities[0]?.name,
              name_mr: data?.localities[0]?.source_stn_localities[0]?.name,
              x: data?.localities[0]?.source_stn_localities[0]?.x_coords,
              y: data?.localities[0]?.source_stn_localities[0]?.y_coords,
            },
            toSt: {
              name: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              code: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code,
              name_hi: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              name_mr: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              x: "",
              y: "",
            }

          }
        }

        if (data?.localities[0]?.destination_stn_localities?.length > 0 && !data?.localities[0]?.source_stn_localities) {
          locality.to = {
            fromSt: {
              name: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              code: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code,
              name_hi: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              name_mr: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              x: "",
              y: "",
            },
            toSt: {
              name: data?.localities[0]?.destination_stn_localities[0]?.name,
              code: "tolt",
              name_hi: data?.localities[0]?.destination_stn_localities[0]?.name,
              name_mr: data?.localities[0]?.destination_stn_localities[0]?.name,
              x: data?.localities[0]?.destination_stn_localities[0]?.x_coords,
              y: data?.localities[0]?.destination_stn_localities[0]?.y_coords,
            }

          }
        }

        if (data?.localities[0]?.source_stn_localities?.length > 0 && data?.localities[0]?.destination_stn_localities?.length > 0) {
          locality.from = {
            fromSt: {
              name: data?.localities[0]?.source_stn_localities[0]?.name,
              code: "fromlt",
              name_hi: data?.localities[0]?.source_stn_localities[0]?.name,
              name_mr: data?.localities[0]?.source_stn_localities[0]?.name,
              x: data?.localities[0]?.source_stn_localities[0]?.x_coords,
              y: data?.localities[0]?.source_stn_localities[0]?.y_coords,
            },
            toSt: {
              name: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              code: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code,
              name_hi: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              name_mr: data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.name,
              x: "",
              y: "",
            }
          }

          locality.to = {
            fromSt: {
              name: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              code: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code,
              name_hi: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              name_mr: data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.name,
              x: "",
              y: "",
            },
            toSt: {
              name: data?.localities[0]?.destination_stn_localities[0]?.name,
              code: "tolt",
              name_hi: data?.localities[0]?.destination_stn_localities[0]?.name,
              name_mr: data?.localities[0]?.destination_stn_localities[0]?.name,
              x: data?.localities[0]?.destination_stn_localities[0]?.x_coords,
              y: data?.localities[0]?.destination_stn_localities[0]?.y_coords,
            }

          }
        }

        setPlottedMap(drawMap(formatData(lang, lines["mmrcl"], coords["mmrcl"], {}), showPopup))
      } else {
        setPlottedMap(drawMap(formatData(lang, lines["mmrcl"], coords["mmrcl"], {}), showPopup))
      }

      const linesData = data.route.flatMap((r: any) => r['map-path'])
      if (linesData.length) {
        highlightPath(linesData, data)
      }
      setRouteData(data)
      setEdit(false)
      Array.prototype.forEach.call(
        document.querySelectorAll(`.fromFlags div`),
        (item) => {
          item.style.visibility = 'hidden'
        }
      );
      Array.prototype.forEach.call(
        document.querySelectorAll(`.toFlags div`),
        (item) => {
          item.style.visibility = 'hidden'
        }
      );
      if (data?.localities?.length > 0 && (data?.localities[0]?.source_stn_localities?.length > 0 || data?.localities[0]?.destination_stn_localities?.length > 0)) {
        if (data?.localities[0]?.source_stn_localities?.length > 0 && !data?.localities[0]?.destination_stn_localities) {
          (document.getElementById(
            data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code + 'fromFlag'
          ) as any).style.visibility = 'visible'
        }

        if (data?.localities[0]?.destination_stn_localities?.length > 0 && !data?.localities[0]?.source_stn_localities) {
          (document.getElementById(
            data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code + 'toFlag'
          ) as any).style.visibility = 'visible';
        }

        if (data?.localities[0]?.destination_stn_localities?.length > 0 && data?.localities[0]?.source_stn_localities?.length > 0) {
          (document.getElementById(
            data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code + 'fromFlag'
          ) as any).style.visibility = 'visible';

          (document.getElementById(
            data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code + 'toFlag'
          ) as any).style.visibility = 'visible';
        }

        if (obj?.fromType === "station") {
          (document.getElementById(
            obj?.from + 'fromFlag'
          ) as any).style.visibility = 'visible';
        }

        if (obj?.toType === "station") {
          (document.getElementById(
            obj?.to + 'toFlag'
          ) as any).style.visibility = 'visible';
        }
      } else {
        (document.getElementById(
          obj?.from + 'fromFlag'
        ) as any).style.visibility = 'visible';
        (document.getElementById(
          obj?.to + 'toFlag'
        ) as any).style.visibility = 'visible'
      }
      setLoading(false)
      setSubmit(false)
    } else {
      let obj: any = {
        from: '',
        fromName: '',
        to: '',
        toName: '',
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
        advanced: 'least-distance',
        fromType: '',
        toType: '',
        journey: "one_way"
      }
      Array.prototype.forEach.call(
        document.querySelectorAll(`.fromFlags div`),
        (item) => {
          item.style.visibility = 'hidden'
        }
      );
      Array.prototype.forEach.call(
        document.querySelectorAll(`.toFlags div`),
        (item) => {
          item.style.visibility = 'hidden'
        }
      );
      Array.from(document.querySelectorAll('.lines line')).forEach((line: any) => {
        line.style.stroke = line.__data__.color
      })
      Array.from(
        document.querySelectorAll(
          '.interchanges rect, .stations path'
        )
      ).forEach((interchange: any) => {
        interchange.style.stroke = '#1AD5FF'
        interchange.style.fill = "#DDDDDD"
      })
      Array.from(
        document.querySelectorAll(
          '.transferStations path'
        )
      ).forEach((interchange: any) => {
        interchange.style.stroke = '#1AD5FF'
        interchange.style.fill = "#DDDDDD"
      })
      setEdit(true)
      setRouteData(null)
      setJourneyPlan(obj)
      !!params?.lang ? navigate(`/${params?.lang}/map`) : navigate(`/map`)
      setNoRouteFound(true)
      setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"))
      setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"))
      setFromErr(false)
      setToErr(false)
      setFromSt(null)
      setToSt(null)
      setToStSearch("")
      setFromStSearch("")
      setLoading(false)
      setSubmit(false)
    }
  }

  document.onkeydown = function (evt: any) {
    if (evt.keyCode === 27) {
      setIsPopupOpen(false)
      setBookErr("")
    }
  };

  useEffect(() => {
    if (isNoRouteFound || !!bookErr) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isNoRouteFound, bookErr]);

  const getFavTrip = async () => {
    try {
      setTripLoading(true)
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.fav_trips}`);

      if (res && res.status === 200) {
        let arr: any[] = []
        for (let i = 0; i < res?.data?.data?.length; i++) {
          const el = res?.data?.data?.[i];
          if (journeyPlan?.fromType === "station" && journeyPlan?.toType === "station") {
            if (el?.from_station?.code === journeyPlan?.from && el?.to_station?.code === journeyPlan?.to) {
              arr.push(el)
            }
          }
          if (journeyPlan?.fromType === "locality" && journeyPlan?.toType === "locality") {
            if (el?.from_locality?.name === journeyPlan?.from && el?.to_locality?.name === journeyPlan?.to) {
              arr.push(el)
            }
          }
          if (journeyPlan?.fromType === "station" && journeyPlan?.toType === "locality") {
            if (el?.from_station?.code === journeyPlan?.from && el?.to_locality?.name === journeyPlan?.to) {
              arr.push(el)
            }
          }
          if (journeyPlan?.fromType === "locality" && journeyPlan?.toType === "station") {
            if (el?.from_locality?.name === journeyPlan?.from && el?.to_station?.code === journeyPlan?.to) {
              arr.push(el)
            }
          }

        }
        if (arr?.length > 0) {
          setSaved(true)
        } else {
          setSaved(false)
        }
        setTripLoading(false)
      }
    } catch (error) {
      console.error("error while fetching fav trips", error);
    }
  }

  useEffect(() => {
    (!!lang && isLogin && !!journeyPlan?.fromType && !!journeyPlan?.toType && !!journeyPlan?.from && !!journeyPlan?.to) && getFavTrip();
  }, [lang, isLogin, journeyPlan])

  const timeStringToDate = (timeString: any) => {
    const today = new Date();
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    today.setHours(hours, minutes, seconds, 0);
    return today;
  }

  return (
    <>
      {/* not found */}
      {isNoRouteFound &&
        <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
          <div
            className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => setNoRouteFound(false)}
          ></div>
          <div className="flex justify-center items-center min-h-screen">
            <div className="m-[15px] md:mx-auto relative bg-white dark:bg-bgDarkDull rounded-[20px] flex flex-col lg:flex-row w-[600px] h-full shadow-[0px_14.134px_69.101px_-3.141px_rgba(24,39,75,0.14),0px_6.282px_21.987px_-4.711px_rgba(24,39,75,0.12)]">
              <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[8px] right-[8px] mm:top-[15px] mm:right-[15px] rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setNoRouteFound(false)}>
                <CloseBtn />
              </button>
              <div className="flex flex-col w-full px-[30px] py-[60px] items-center justify-center">
                <div className="min-w-[105px] h-[105px] flex items-center justify-center rounded-full bg-secDarkRed">
                  <img src={require("../../../assets/images/service-fail.gif")} alt="service-fail" className="w-[81px] h-[81px]" />
                </div>
                {(!!journeyData?.['Error Message'] && journeyData?.return_journey) ?
                  <>
                    <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.no_route_found.line1")}</h3>
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[10px] text-center">{journeyData?.['Error Message']}</h6>
                  </>
                  : <>
                    <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.no_route_found.line1")}</h3>
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[10px] text-center">{t("passenger.map.no_route_found.line2")}</h6>
                    <SecondaryBtn onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/line-details`) : navigate(`/line-details`); setNoRouteFound(false); }} title={t("passenger.map.no_route_found.view_status")} css="!rounded-[10px] px-[40px] font-extrabold uppercase !h-[35px] mt-[30px]" />
                  </>}
              </div>
            </div>
          </div>
        </div>
      }

      {/* other err */}
      {((!!bookErr) && !isNoRouteFound) &&
        <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
          <div
            className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => setBookErr("")}
          ></div>
          <div className="flex justify-center items-center min-h-screen">
            <div className="m-[15px] md:mx-auto relative bg-white dark:bg-bgDarkDull rounded-[20px] flex flex-col lg:flex-row w-[600px] h-full shadow-[0px_14.134px_69.101px_-3.141px_rgba(24,39,75,0.14),0px_6.282px_21.987px_-4.711px_rgba(24,39,75,0.12)]">
              <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[8px] right-[8px] mm:top-[15px] mm:right-[15px] rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setBookErr("")}>
                <CloseBtn />
              </button>
              <div className="flex flex-col w-full px-[30px] py-[60px] items-center justify-center">
                <div className="min-w-[105px] h-[105px] flex items-center justify-center rounded-full bg-secDarkRed">
                  <img src={bookErr === "soon" ? require("../../../assets/images/hour.gif") : require("../../../assets/images/hour.gif")} alt="warning" className="w-[100px] h-[100px]" />
                </div>
                {bookErr === "soon" ? <>
                  <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.book_soon.line1")}</h3>
                  {/* <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[10px] text-center">{!!downtime?.metro_downtime_to ? `${lang === "en" ? `You'll be able to book your tickets starting from ${moment(downtime?.metro_downtime_to).format('Do MMMM')}.` : lang === "hi" ? `आप ${moment(downtime?.metro_downtime_to).format('Do MMMM')} से अपने टिकट बुक कर सकेंगे।` : `तुम्ही ${moment(downtime?.metro_downtime_to).format('Do MMMM')} पासून तुमची तिकिटे बुक करू शकाल.`}` : t("passenger.map.book_soon.line2")}</h6> */}
                  <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[10px] text-center">{downtime?.message}</h6>
                  <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[2px] text-center">{t("passenger.map.book_soon.line3")}</h6>
                </> :
                  <>
                    <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.hours_err.line1")}</h3>
                    {/* <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[10px] text-center max-w-[390px]">{(!!downtime?.first_ticket_time && !!downtime?.last_ticket_time) ? `${lang === "en" ? `Ticket booking is available daily from ${moment(timeStringToDate(downtime?.first_ticket_time)).format('hh:mm A')} to ${moment(timeStringToDate(downtime?.last_ticket_time)).format('hh:mm A')}. Plan your journey accordingly.` : lang === "hi" ? `टिकट बुकिंग रोजाना सुबह ${moment(timeStringToDate(downtime?.first_ticket_time)).format('hh:mm')} बजे से रात ${moment(timeStringToDate(downtime?.last_ticket_time)).format('hh:mm')} बजे तक उपलब्ध है। तदनुसार अपनी यात्रा की योजना बनाएं।` : `तिकीट बुकिंग दररोज सकाळी ${moment(timeStringToDate(downtime?.first_ticket_time)).format('hh:mm')} ते रात्री ${moment(timeStringToDate(downtime?.last_ticket_time)).format('hh:mm')} पर्यंत उपलब्ध आहे. त्यानुसार तुमच्या प्रवासाचे नियोजन करा.`}` : t("passenger.map.hours_err.line2")}</h6> */}
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[10px] text-center max-w-[390px]">{downtime?.message}</h6>
                  </>
                }
                <SecondaryBtn onClick={() => setBookErr("")} title={t("lang.go_back")} css="!rounded-[10px] px-[40px] font-extrabold uppercase !h-[35px] mt-[30px]" />
              </div>
            </div>
          </div>
        </div>
      }
      {loading && <div className="w-full flex items-center justify-center py-[100px] xlx:py-[145px] h-full">
        <h1 className="text-primary font-black text-2xl max-w-[200px] text-center flex items-center uppercase gap-[2px]">Loading
          <div className="loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </h1>
      </div>}
      <div className={`items-center justify-center w-full h-full px-[18px] xsm:px-[25px] xlx:px-[45px] ${!loading ? "flex" : "hidden"}`}>
        <div className="flex justify-end items-end h-full w-full mms:flex-row flex-col mms:w-[1200px] xlx:w-[1384px] gap-[20px] xlx:gap-[30px]">
          <PlanJouney edit={edit} setEdit={setEdit} setJourneyPlan={setJourneyPlan} journeyPlan={journeyPlan} routeData={routeData} setRouteData={setRouteData} fromStPh={fromStPh} setFromStPh={setFromStPh} fromStSearch={fromStSearch} setFromStSearch={setFromStSearch} toStSearch={toStSearch} setToStSearch={setToStSearch} toStPh={toStPh} setToStPh={setToStPh} fromErr={fromErr} setFromErr={setFromErr} toErr={toErr} setToErr={setToErr} fromSt={fromSt} setFromSt={setFromSt} toSt={toSt} setToSt={setToSt} saveRoute={saveRoute} setSaveRoute={setSaveRoute} submit={submit} fromData={fromData} setFromData={setFromData} tripLoading={tripLoading} saved={saved} toData={toData} setToData={setToData} getFavTrip={getFavTrip} type={type} setType={setType} setBookErr={setBookErr} setDownTime={setDownTime} downtime={downtime} />

          <div className="pt-[20px] mms:py-[30px] w-full mms:w-[calc(100%-400px)] xlx:w-[calc(100%-460px)] h-full mms:order-2 order-1">
            <div className="w-full bg-[#a3dbf3] h-[400px] mms:h-full relative rounded-[20px]">
              <Popup isPopupOpen={isPopupOpen} stationName={lastClickedStation} handleButtonClick={handleButtonClick} setIsPopupOpen={setIsPopupOpen} />
              <div id='map' className="map-image w-full h-full rounded-[20px]" />

              <div className="absolute right-[20px] xlx:right-[30px] bottom-[20px] xlx:bottom-[30px] flex flex-col gap-[8px]">
                <button aria-label={t("aria_label.zoom_in")} title={t("aria_label.zoom_in")} className="focus-within:outline-none focus:outline-none min-w-[30px] min-h-[30px] sm:min-w-[35px] sm:min-h-[35px] 1xl:min-w-[40px] 1xl:min-h-[40px] group focus:shadow-[0_0_6px_0px_#32435F] rounded-[10px]" onClick={() => { zoomIn(); setIsPopupOpen(false); }}>
                  <div className="bg-white dark:bg-bgDarkDull group-hover:bg-[#202020] rounded-[10px] flex items-center justify-center min-w-[30px] min-h-[30px] sm:min-w-[35px] sm:min-h-[35px] 1xl:min-w-[40px] 1xl:min-h-[40px] border border-[#D1D1D1]  shadow-[0px_8px_24px_-4px_rgba(24,39,75,0.08),0px_6px_12px_-6px_rgba(24,39,75,0.12)] relative z-[1]"><AddZoom className="group-hover:fill-white fill-primary sm:w-auto sm:h-auto w-[12px] h-[12px]" /></div>
                </button>
                <button aria-label={t("aria_label.zoom_out")} title={t("aria_label.zoom_out")} className="focus-within:outline-none focus:outline-none min-w-[30px] min-h-[30px] sm:min-w-[35px] sm:min-h-[35px] 1xl:min-w-[40px] 1xl:min-h-[40px] group focus:shadow-[0_0_6px_0px_#32435F] rounded-[10px]" onClick={() => { zoomOut(); setIsPopupOpen(false); }}>
                  <div className="bg-white dark:bg-bgDarkDull group-hover:bg-[#202020] rounded-[10px] flex items-center justify-center min-w-[30px] min-h-[30px] sm:min-w-[35px] sm:min-h-[35px] 1xl:min-w-[40px] 1xl:min-h-[40px] border border-[#D1D1D1] shadow-[0px_8px_24px_-4px_rgba(24,39,75,0.08),0px_6px_12px_-6px_rgba(24,39,75,0.12)] relative z-[1]"><Minus className="group-hover:fill-white fill-primary sm:w-auto sm:h-auto w-[12px] h-[12px]" /></div>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Map;